/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { ErrorType } from "../../apix-handler";
import type {
  AuthTokenJwksResponse,
  AuthTokenResponse,
  AuthTokenServiceTokenPostV2Params,
  WellKnownJwksJsonGetV2Params,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Generate a short-lived RS256-signed JWT for a BT service.
Replicates Auth0 claim structure for future compatibility.
 */
export const authTokenServiceTokenPostV2 = (
  params?: AuthTokenServiceTokenPostV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AuthTokenResponse>(
    { url: `/apix/v2/AuthToken/service-token`, method: "POST", params, signal },
    options,
  );
};

export const getAuthTokenServiceTokenPostV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authTokenServiceTokenPostV2>>,
    TError,
    { params?: AuthTokenServiceTokenPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authTokenServiceTokenPostV2>>,
  TError,
  { params?: AuthTokenServiceTokenPostV2Params },
  TContext
> => {
  const mutationKey = ["authTokenServiceTokenPostV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authTokenServiceTokenPostV2>>,
    { params?: AuthTokenServiceTokenPostV2Params }
  > = (props) => {
    const { params } = props ?? {};

    return authTokenServiceTokenPostV2(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthTokenServiceTokenPostV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof authTokenServiceTokenPostV2>>
>;

export type AuthTokenServiceTokenPostV2MutationError = ErrorType<unknown>;

/**
 * @summary Generate a short-lived RS256-signed JWT for a BT service.
Replicates Auth0 claim structure for future compatibility.
 */
export const useAuthTokenServiceTokenPostV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authTokenServiceTokenPostV2>>,
    TError,
    { params?: AuthTokenServiceTokenPostV2Params },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof authTokenServiceTokenPostV2>>,
  TError,
  { params?: AuthTokenServiceTokenPostV2Params },
  TContext
> => {
  const mutationOptions =
    getAuthTokenServiceTokenPostV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Stability Level**: `draft`
 * @summary JWKS endpoint exposing the public key for auth token validation (RFC 7517).
Consuming services fetch this to verify tokens without sharing a secret.
 */
export const wellKnownJwksJsonGetV2 = (
  params?: WellKnownJwksJsonGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AuthTokenJwksResponse>(
    { url: `/apix/.well-known/jwks.json`, method: "GET", params, signal },
    options,
  );
};

export const getWellKnownJwksJsonGetV2QueryKey = (
  params?: WellKnownJwksJsonGetV2Params,
) => {
  return [`/apix/.well-known/jwks.json`, ...(params ? [params] : [])] as const;
};

export const getWellKnownJwksJsonGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof wellKnownJwksJsonGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: WellKnownJwksJsonGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof wellKnownJwksJsonGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWellKnownJwksJsonGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof wellKnownJwksJsonGetV2>>
  > = ({ signal }) => wellKnownJwksJsonGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wellKnownJwksJsonGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type WellKnownJwksJsonGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof wellKnownJwksJsonGetV2>>
>;
export type WellKnownJwksJsonGetV2QueryError = ErrorType<unknown>;

/**
 * @summary JWKS endpoint exposing the public key for auth token validation (RFC 7517).
Consuming services fetch this to verify tokens without sharing a secret.
 */

export function useWellKnownJwksJsonGetV2<
  TData = Awaited<ReturnType<typeof wellKnownJwksJsonGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: WellKnownJwksJsonGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof wellKnownJwksJsonGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getWellKnownJwksJsonGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
